import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { APIListWrapper } from '../models/common/api-list-wrapper.model';
import { APIResponseWrapper } from '../models/common/api-response-wrapper';
import { FleetDocument, FleetDocumentSearchParams } from './fleet-documents.model';

@Injectable({ providedIn: 'root' })
export class FleetDocumentsService {
  private readonly baseUrl = `${environment.restApiUrl}fleet-documents`;

  constructor(private http: HttpClient) {}

  search(filters: FleetDocumentSearchParams = {}): Observable<APIListWrapper<FleetDocument>> {
    let params = new HttpParams()
      .set('page', filters.page ?? 0)
      .set('pageSize', filters.pageSize ?? 50);
    for (const key of ['resourceType', 'resourceId', 'documentType', 'status', 'expiryFrom', 'expiryTo']) {
      params = this.appendIfPresent(params, key, (filters as Record<string, unknown>)[key]);
    }
    return this.http.get<APIListWrapper<FleetDocument>>(this.baseUrl, { params });
  }

  create(document: FleetDocument): Observable<APIResponseWrapper<FleetDocument>> {
    return this.http.post<APIResponseWrapper<FleetDocument>>(this.baseUrl, document);
  }

  update(documentId: number, document: FleetDocument): Observable<APIResponseWrapper<FleetDocument>> {
    return this.http.put<APIResponseWrapper<FleetDocument>>(`${this.baseUrl}/${documentId}`, document);
  }

  evaluateCurrentTenant(): Observable<APIResponseWrapper<FleetDocument[]>> {
    return this.http.post<APIResponseWrapper<FleetDocument[]>>(`${this.baseUrl}/evaluate`, {});
  }

  private appendIfPresent(params: HttpParams, key: string, value: unknown): HttpParams {
    if (value === null || value === undefined || value === '') {
      return params;
    }
    return params.set(key, value instanceof Date ? value.toISOString() : value.toString());
  }
}
